import React from 'react';
import { InvoiceData, QuoteData } from '../types';

interface ClientInfoSectionProps {
  data: InvoiceData | QuoteData;
  accentColor?: string;
}

/**
 * Section d'affichage des informations du client
 * Compatible avec les factures et les devis
 */
export const ClientInfoSection: React.FC<ClientInfoSectionProps> = ({
  data,
  accentColor = '#0D9488'
}) => {
  // Utilise UNIQUEMENT la structure Prisma V2 (pas de fallback legacy)
  const clientName = (data as any).Client?.fullName;
  const clientCompany = (data as any).Client?.companyName;
  const clientPosition = (data as any).Client?.position; // Fonction/titre
  const clientAddress = (data as any).Client?.addressLine1;
  const clientCity = (data as any).Client?.city;
  const clientZip = (data as any).Client?.zipCode;
  const clientPhone = (data as any).Client?.phone;
  const clientEmail = (data as any).Client?.email;

  // Si aucune info client n'est disponible
  if (!clientName && !clientCompany && !clientAddress && !clientEmail) {
    return null;
  }

  return (
    <div className="text-xs md:text-sm text-gray-800">
      {/* Nom ou Société (en gras) */}
      {(clientCompany || clientName) && (
        <p className="font-semibold text-gray-900">
          {clientCompany || clientName}
        </p>
      )}

      {/* Nom du contact si société présente */}
      {clientCompany && clientName && (
        <p>{clientName}</p>
      )}

      {/* Fonction/Titre (affiché sous le nom, multi-lignes supporté) */}
      {clientPosition && (
        <p className="text-gray-700 whitespace-pre-line">{clientPosition}</p>
      )}

      {/* Adresse */}
      {clientAddress && (
        <p>{clientAddress}</p>
      )}

      {/* Code postal et Ville */}
      {(clientZip || clientCity) && (
        <p>
          {clientZip} {clientCity}
        </p>
      )}

      {/* Téléphone */}
      {clientPhone && (
        <p className="mt-1">{clientPhone}</p>
      )}

      {/* Email */}
      {clientEmail && (
        <p style={{ color: accentColor }}>{clientEmail}</p>
      )}
    </div>
  );
};
